import type { ReactNode } from 'react';
import { NavBar } from './NavBar';
import { BottomTabBar } from './BottomTabBar';

interface AppLayoutProps {
  children: ReactNode;
}

/**
 * AppLayout - Main layout wrapper for authenticated app pages
 * 
 * Safe area handling:
 * - NavBar has `safe-top` for iOS notch
 * - BottomTabBar has `safe-bottom` for iOS home indicator
 * - Content area accounts for both nav heights + safe areas
 * 
 * The padding uses CSS calc to combine:
 * - Fixed nav height (4rem / 64px)
 * - Safe area inset (from CSS env variables)
 */
export function AppLayout({ children }: AppLayoutProps) {
  return (
    <div 
      className="min-h-screen"
      style={{
        // Top padding: NavBar height (4rem) + safe area
        paddingTop: 'calc(4rem + var(--safe-area-inset-top, 0px))',
        // Bottom padding: BottomTabBar height (4rem) + safe area (mobile only handled by CSS)
        paddingBottom: 'calc(4rem + var(--safe-area-inset-bottom, 0px))',
      }}
    >
      <NavBar />
      <main className="mx-auto">
        {children}
      </main>
      <BottomTabBar />
    </div>
  );
}
